import * as React from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import { SortReportViewModel } from '../ViewModels/ReportViewModel';
import ReportTable from './ReportTable';

interface IMonthlyProps {
    accounts: SortReportViewModel[]
    reportLoaded: boolean;
}

export default function MonthlyReport(props: IMonthlyProps) {

    return (
        <React.Fragment>
            {!props.reportLoaded ? <LinearProgress color="primary" /> :
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <ReportTable accounts={props.accounts} isMonthly/>
                    </Grid>
                </Grid>
            }
        </React.Fragment>
    );
}